import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { ProductListView } from './list-view/product.list-view';

export const productFieldOk: FieldOkConfig = {
  name: 'product',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ProductListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};

export const productMultiselectFieldOk: FieldOkConfig = {
  name: 'product',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: ProductListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};

export const productQueryFieldOk: FieldOkConfig = {
  name: 'product',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ProductListView,
        sort: {
          properties: [{ property: 'bezeichnung', title: 'Bezeichnung' }],
        },
      },
    },
  ],
};
